<template>
    <div>
        <el-row class="container p-24 p-lr-100" gutter="40">
            <el-col :span="6">
                <div class="card-desktop">
                    <CardDesktop :ruleForm="ruleForm"></CardDesktop>
                </div>
            </el-col>
            <el-col :span="18" class="card-form">
                <el-card style="border-radius: 16px" class="p-lr-40 p-tb-10">
                    <template #header>
                        <el-row justify="space-between" align="middle" class="card-header">
                            <el-col class="font-20 w-600 text-333" :span="12">Business Card Fields</el-col>
                            <el-col :span="12" style="text-align: right">
                                <el-button size="large" @click="$router.push('/')">Back</el-button>
                                <el-button class="" :disabled="ruleForm.cardName != '' ? false : true" size="large" type="success" @click="submitForm(ruleFormRef)">Create</el-button>
                            </el-col>
                        </el-row>
                    </template>

                    <el-form ref="ruleFormRef" style="" :model="ruleForm" :rules="rules" label-width="auto" label-position="top" require-asterisk-position="right">
                        <el-form-item label="Card Name" class="card-name">
                            <el-input v-model="ruleForm.cardName" />
                        </el-form-item>

                        <p class="title-text">Add Images</p>
                        <el-row>
                            <el-col :span="12">
                                <div class="flex col-center m-b-10">
                                    <span style="margin-right: 5px" class="font-14">Company Logo</span>
                                    <el-popover class="box-item" placement="top-start" width="500" effect="dark">
                                        <template #default>
                                            <ul style="list-style: disc" class="p-lr-15">
                                                <li>Allow common image formats: PNG, JPG, JPEG, SVG</li>
                                                <li>Set a maximum file size 2MB</li>
                                                <li>Recommend a minimum resolution (300x300px) to avoid pixelation.</li>
                                                <li>Set a maximum resolution (1000x1000px) to prevent oversized images.</li>
                                            </ul>
                                        </template>
                                        <template #reference>
                                            <el-icon color="#333333">
                                                <Warning />
                                            </el-icon>
                                        </template>
                                    </el-popover>
                                </div>

                                <div>
                                    <el-avatar :size="200" :src="companyLogo" style="cursor: pointer" @click="avatarCropperVisibleChange('1')" />
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="flex col-center m-b-10">
                                    <span style="margin-right: 5px" class="font-14">Display Picture</span>
                                    <el-popover class="box-item" placement="top-start" width="500" effect="dark">
                                        <template #default>
                                            <ul style="list-style: disc" class="p-lr-15">
                                                <li>Allow common image formats: PNG, JPG, JPEG, SVG</li>
                                                <li>Set a maximum file size 2MB</li>
                                                <li>Recommend a minimum resolution (300x300px) to avoid pixelation.</li>
                                                <li>Set a maximum resolution (1000x1000px) to prevent oversized images.</li>
                                            </ul>
                                        </template>
                                        <template #reference>
                                            <el-icon color="#333333">
                                                <Warning />
                                            </el-icon>
                                        </template>
                                    </el-popover>
                                </div>

                                <div>
                                    <el-avatar :size="200" :src="displayPicture" style="cursor: pointer" @click="avatarCropperVisibleChange('2')" />
                                </div>
                            </el-col>
                        </el-row>
                        <p class="title-text">Choose Primary Colors</p>
                        <div class="color-picker-container">
                            <div class="vip-color">
                                <el-color-picker disabled />
                                <img src="@/assets/vipIcon.png" alt="" />
                            </div>
                            <ul class="color-picker-list">
                                <div class="color-picker-list-item" :style="{ borderColor: ruleForm.primaryColors == '#5133af' ? '#5133af' : '' }">
                                    <li class="" style="background-color: #5133af" @click="colorChange('#5133af')"></li>
                                </div>
                                <div class="color-picker-list-item" :style="{ borderColor: ruleForm.primaryColors == '#b120b2' ? '#b120b2' : '' }">
                                    <li class="" style="background-color: #b120b2" @click="colorChange('#b120b2')"></li>
                                </div>
                                <div class="color-picker-list-item" :style="{ borderColor: ruleForm.primaryColors == '#bd0000' ? '#bd0000' : '' }">
                                    <li class="" style="background-color: #bd0000" @click="colorChange('#bd0000')"></li>
                                </div>
                                <div class="color-picker-list-item" :style="{ borderColor: ruleForm.primaryColors == '#efb700' ? '#efb700' : '' }">
                                    <li class="" style="background-color: #efb700" @click="colorChange('#efb700')"></li>
                                </div>
                                <div class="color-picker-list-item" :style="{ borderColor: ruleForm.primaryColors == '#007e40' ? '#007e40' : '' }">
                                    <li class="" style="background-color: #007e40" @click="colorChange('#007e40')"></li>
                                </div>
                            </ul>
                        </div>
                        <p class="title-text">
                            <span>Choose Font</span>
                            <img src="@/assets/vipIcon.png" alt="" />
                        </p>
                        <el-select v-model="ruleForm.chooseFont" placeholder="Select" disabled>
                            <template #label="{ label }">
                                <span style="background: #0e0111; padding: 4px 8px; border-radius: 4px; color: #fff">{{ label }}</span>
                            </template>
                            <el-option label="Default" value="Default" />
                        </el-select>
                        <p class="title-text">Personal</p>
                        <el-row gutter="24">
                            <el-col :span="12">
                                <el-form-item label="Full Name" prop="fullName">
                                    <el-input v-model="ruleForm.fullName" placeholder="Full Name" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Job Title" prop="jobTitle">
                                    <el-input v-model="ruleForm.jobTitle" placeholder="Job Title" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row gutter="24">
                            <el-col :span="12">
                                <el-form-item label="Company Name" prop="companyName">
                                    <el-input v-model="ruleForm.companyName" placeholder="Company Name" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Department" prop="department">
                                    <el-input v-model="ruleForm.department" placeholder="Department" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row gutter="24">
                            <el-col :span="24">
                                <el-form-item label="Blurb">
                                    <el-input type="textarea" rows="4" v-model="ruleForm.blurb" placeholder="Sentence about themselves, company etc.  Limit of 50 characters" />
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <p class="title-text">General</p>
                        <el-row gutter="24">
                            <el-col :span="12">
                                <el-form-item label="Email Address" prop="emailAddress">
                                    <el-input v-model="ruleForm.emailAddress" placeholder="Example: info@emali.limited" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Mobile Number" prop="mobileNumber">
                                    <el-input v-model="ruleForm.mobileNumber" placeholder="Example: +852 00000000" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row gutter="24">
                            <el-col :span="12">
                                <el-form-item label="Website">
                                    <el-input v-model="ruleForm.website" placeholder="URL of your company website" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Customisable link">
                                    <el-input v-model="ruleForm.customisableLink" placeholder="Link to your own items" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row gutter="24">
                            <el-col :span="24">
                                <el-form-item label="Company Address">
                                    <el-input v-model="ruleForm.companyAddress" placeholder="Company Address" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row gutter="24">
                            <el-col :span="24">
                                <el-form-item label="Accreditations">
                                    <el-input v-model="ruleForm.accreditations" placeholder="Qualifications and certifications #1" />
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <p class="title-text">Messaging</p>
                        <el-row gutter="24">
                            <el-col :span="12">
                                <el-form-item label="WeChat">
                                    <el-input v-model="ruleForm.wechat" placeholder="WeChat ID" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Whatsapp">
                                    <el-input v-model="ruleForm.whatsapp" placeholder="Whatsapp Number" />
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <p class="title-text">Social</p>
                        <el-row gutter="24">
                            <el-col :span="12">
                                <el-form-item label="Linkedin">
                                    <el-input v-model="ruleForm.linkedin" placeholder="URL of users Linkedin profile" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Instagram">
                                    <el-input v-model="ruleForm.instagram" placeholder="URL of Instagram profile" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row gutter="24">
                            <el-col :span="12">
                                <el-form-item label="X">
                                    <el-input v-model="ruleForm.xProfile" placeholder="URL of X profile" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Facebook">
                                    <el-input v-model="ruleForm.facebook" placeholder="URL of Facebook profile" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
        <avatarCropper v-if="dialogVisible" :circleType="circleType" :dialogVisible.sync="dialogVisible" @closeAvatarDialog="closeAvatarDialog"></avatarCropper>
    </div>
</template>
<script setup>
import avatarCropper from '@/components/avatarCropper.vue';
import CardDesktop from '@/components/cardDesktop.vue';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { createCard } from '@/api/card.js';
let validateEmail = (rule, value, callback) => {
    let reg = /^([a-zA-Z0-9_.+-]+)@(([a-zA-Z0-9-]+\.)+[a-zA-Z0-9-.]+)$/;

    if (value === undefined || value === '') {
        callback(new Error('Please input Email Address'));
    } else if (!reg.test(value)) {
        callback(new Error('Incorrect email format'));
    } else {
        callback();
    }
};
const router = useRouter();
const companyLogo = ref(require('../assets/uploadBg.png')); // Default image URL for the avatar
const displayPicture = ref(require('../assets/uploadBg.png')); // Default image URL for the avatar
const dialogVisible = ref(false);
const circleType = ref('1');
// 打开头像裁剪弹框
const avatarCropperVisibleChange = type => {
    dialogVisible.value = true;
    circleType.value = type; // 设置裁剪类型
};
// 关闭弹框所触发的事件
const closeAvatarDialog = (data, id, type) => {
    if (type === '1' && data !== '') {
        companyLogo.value = data === '' ? require('../assets/uploadBg.png') : data;
        ruleForm.value.companyLogo = id;
    } else if (type === '2' && data !== '') {
        displayPicture.value = data === '' ? require('../assets/uploadBg.png') : data;
        ruleForm.value.displayPicture = id;
    }
    dialogVisible.value = false;
};

const ruleFormRef = ref(null);
const ruleForm = ref({
    cardName: '',
    companyLogo: '',
    displayPicture: '',
    primaryColors: '#5133af',
    chooseFont: 'Default',
    fullName: '', //必填
    jobTitle: '',
    companyName: '', //必填
    department: '',
    blurb: '',
    emailAddress: '',
    mobileNumber: '',
    website: '',
    customisableLink: '',
    companyAddress: '',
    accreditations: '',
    wechat: '',
    whatsapp: '',
    linkedin: '',
    instagram: '',
    xProfile: '',
    facebook: ''
});
const rules = ref({
    fullName: [{ required: true, message: 'Please input Full Name', trigger: 'blur' }],
    companyName: [{ required: true, message: 'Please input Company Name', trigger: 'blur' }],
    emailAddress: [{ required: true, validator: validateEmail, trigger: 'blur' }],
    jobTitle: [{ required: true, message: 'Please input Job Title', trigger: 'blur' }],
    department: [{ required: true, message: 'Please input Department', trigger: 'blur' }],
    mobileNumber: [{ required: true, message: 'Please input Mobile Number', trigger: 'blur' }]
});

const colorChange = color => {
    ruleForm.value.primaryColors = color;
};

const submitForm = async formEl => {
    if (!formEl) return;
    await formEl.validate((valid, fields) => {
        if (valid) {
            createCard(ruleForm.value)
                .then(res => {
                    if (res.code === 200) {
                        router.push({ path: '/ConfirmationPage' });
                        localStorage.setItem('cardId', res.data.id); // Store the card ID in localStorage
                    } else {
                        console.error('Error creating card:', res.message);
                    }
                })
                .catch(error => {
                    console.error('API error:', error);
                });
        } else {
            const errDom = ruleFormRef.value.$el.querySelectorAll('.is-error');
            errDom[0].scrollIntoView({ block: 'center', behavior: 'smooth' });

            console.log('error submit!', fields);
        }
    });
};
</script>
<style lang="scss" scoped>
.title-text {
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
    margin-top: 30px;
    img {
        margin-left: 8px;
        width: 16px;
        height: 16px;
    }
}

.container {
    min-height: calc(100vh - 64px);
    background: #f3f4f6;

    .card-desktop {
        position: fixed;
        width: 21%;
        overflow-y: auto;
        max-height: 80vh;
    }

    .card-form {
        ::v-deep .el-card__header {
            border-color: #e2e2e2;
            padding-left: 0;
            padding-right: 0;
        }

        ::v-deep .el-card__body {
            padding: 40px 0 !important;
        }

        .card-name {
            ::v-deep .el-form-item__label {
                font-weight: 600;
                font-size: 20px;
                color: #333333;
                margin-bottom: 20px;
            }
        }

        .avatar-uploader-box {
            position: relative;
            width: 200px;
            height: 200px;
            background: #e6e6e6;
            border-radius: 50%;
            text-align: center;

            .avatar-uploader-box-icon {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }

        .color-picker-container {
            display: flex;
            align-items: center;
            .vip-color {
                position: relative;
                img {
                    position: absolute;
                    top: 70%;
                    left: 85%;
                    transform: translate(-50%, -50%);
                    width: 16px;
                    height: 16px;
                }
            }

            .color-picker-list {
                display: flex;
                align-items: center;

                .color-picker-list-item {
                    border: 1px solid transparent;
                    padding: 4px;
                    margin-left: 24px;
                    border-radius: 50%;
                    > li {
                        position: relative;
                        cursor: pointer;
                        width: 32px;
                        height: 32px;
                        border-radius: 100px;
                        margin-bottom: 0;
                        border: 1px solid #e2e2e2;
                        padding: 5px;
                    }
                }
            }
        }
    }
}
</style>
